module.exports = __webpack_public_path__ + "static/media/3-.73c7b617.webp";